import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type ReStudentSummaryRoute from 'teacher-ui-client/reporting/ui-scope/re/student-summary/route'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export default class extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>
    const { student } = this.modelFor('reporting.ui-scope.re.student-summary') as ModelFor<ReStudentSummaryRoute>

    const statsScope: StudentsScope = { scope: 'students', ids: [student.id] }

    const product: LegacyProductRe = 're'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return {
      product,
      period,
      student,
      students: scopedData.students,
      ...stats,
    }
  }

  makeStatsRequests(product: LegacyProductRe, scope: StudentsScope, period: NormalizedInterval) {
    const { studentEvents } = this
    return RSVP.hash({
      courseProgressReading: studentEvents.courseProgressLessonsStudent(product, 'reading', scope, period),
      assessmentScoresStudent: studentEvents.assessmentScoresStudent(product, scope, period),
      lexileDetailsStudent: studentEvents.lexileDetailsStudent(product, scope, period),
      drivingTestsStudent: studentEvents.drivingTestsStudentRe(product, scope, period),
      booksReadStudent: studentEvents.booksReadStudent(product, scope, period),
      courseProgressSpelling: studentEvents.courseProgressSpellingStudent(product, 'spelling', scope, period),
      awardsEarnedByMonthEvents: studentEvents.awardsEarnedByMonthEvents(product, scope, period),
      storiesWrittenStudent: studentEvents.storiesWrittenStudent(product, scope, period),
      storylandsStudent: studentEvents.storylandsStudent(product, scope, period),
    })
  }
}
